<template>
  <div class="page">
    <Header title="活动画廊" :show-back="true">
      <span class="nav-right-text" slot="right" @click.stop="viewSubmission">我要投稿</span>
    </Header>

    <van-row class="category-container">
      <van-col v-for="category in categoryList" :key="category.categoryId" span="12">
        <div class="category-image">
          <img :src="getImageUrl(category.categoryImageUri)" @click="viewCategory(category)" />
        </div>
        <div class="category-name">{{ category.categoryName }}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Header from '@/components/header'
import galleryApi from '@/api/gallery'
import { commonUtils } from '@/utils/common'
export default {
  name: 'GalleryCategoryList',
  components: {
    Header
  },
  data () {
    return {
      categoryList: []
    }
  },
  created () {
    this.queryCategoryList()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,

    queryCategoryList () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取数据'
      })
      galleryApi.queryGalleryCategoryList().then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.categoryList = response.data.resultData.categoryList
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    viewCategory (category) {
      this.$router.push({ name: 'gallery-photo-list', params: { categoryId: category.categoryId } })
    },

    viewSubmission () {
      this.$router.push('/gallery/submission')
    }
  }
}
</script>

<style lang="less" scoped>
.category-container {
  margin-top: 16px;
  margin-bottom: 16px;
}

.category-image {
  width: 90%;
  margin: 5px auto 10px auto;
  height: 120px;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 120px;
  }
}

.category-name {
  color: #117281;
  line-height: 24px;
  padding-left: 12px;
}

</style>
